export const OverlayMessageBoxContent = ({ ...props }) => (
  <div className="bg-light flex flex-auto flex-col px-5 py-4" {...props} />
);
